import { render, staticRenderFns } from "./pii-and-non-pii-info.vue?vue&type=template&id=555d8550&scoped=true&"
import script from "./pii-and-non-pii-info.vue?vue&type=script&lang=js&"
export * from "./pii-and-non-pii-info.vue?vue&type=script&lang=js&"
import style0 from "./pii-and-non-pii-info.vue?vue&type=style&index=0&id=555d8550&lang=scss&scoped=true&"
import style1 from "@/assets/otp-input.scss?vue&type=style&index=1&id=555d8550&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555d8550",
  null
  
)

component.options.__file = "pii-and-non-pii-info.vue"
export default component.exports